// API-safe colors that can be used in external integrations like Stripe iframes
export const STRIPE_COMMON_COLORS = {
  DANGER_RED: 'var(--cds-color-red-750)',
  BORDER_GRAY: 'var(--cds-color-grey-400)',
  SECONDARY_TEXT: 'var(--cds-color-grey-850)',
  BACKGROUND_PRIMARY: 'var(--cds-color-neutral-background-primary)',
  INPUT_BACKGROUND_PRIMARY: 'var(--cds-color-neutral-background-primary)',
  INPUT_BORDER_COLOR: 'var(--cds-color-neutral-stroke-primary-weak)',
} as const;

export const STRIPE_PAYMENT_COLORS = {
  ...STRIPE_COMMON_COLORS,
  PRIMARY_TEXT: 'var(--cds-color-neutral-primary)',
  PRIMARY_BLUE: 'var(--cds-color-blue-700)',
  SUCCESS_GREEN: 'var(--cds-color-green-700)',
} as const;

export const STRIPE_TEAMS_COLORS = {
  ...STRIPE_COMMON_COLORS,
  BORDER_LIGHT_GRAY: 'var(--cds-color-grey-100)',
  PRIMARY_TEXT: 'var(--cds-color-grey-975)',
  HOVER_BACKGROUND: 'var(--cds-color-blue-25)',
  PRIMARY_BLUE: 'var(--cds-color-blue-800)',
  SECONDARY_BORDER: 'var(--cds-color-grey-400)',
  INPUT_TEXT: 'var(--cds-color-green-850)',
} as const;
